export const SOURCE_STRINGS = {
  Aktualne: 'Aktuálně.cz',
  Vareni: 'Vaření.cz',
  Woman: 'Žena.cz',
  Respekt: 'Respekt',
  Nova: 'TN.cz',
  Blesk: 'Blesk.cz',
  Utulne: 'Útulně',
  Studenta: 'Studenta',
  Video: 'Aktuálně.cz',
  IhnedByznys: 'Ihned',
  IhnedDomaci: 'Ihned',
  IhnedZahranicni: 'Ihned',
  IhnedNazory: 'Ihned',
  IhnedArt: 'Ihned',
  IhnedEgo: 'Ihned',
  IhnedTech: 'Ihned',
  Magazin: 'Aktuálně.cz',
  Maminka: 'Super mámy',
  MagazinZahrada: 'Magazín zahrada',
  AktualneAuto: 'Aktuálně.cz',
  FashionMagazin: 'Fashion Magazín',
  VyberMiAuto: 'VybermiAuto.cz',
  VitalWeb: 'Vitalweb.cz',
  BabySUV: 'BabySUV',
  CzechSight: 'CzechSight'
}

export const SOURCE_IMAGES = {
  Aktualne: 'aktualne.svg',
  Vareni: 'vareni.svg',
  Woman: 'zena.svg',
  Respekt: 'respekt.svg',
  Nova: 'tn.svg',
  Blesk: 'blesk.svg',
  Utulne: 'utulne.svg',
  Studenta: 'studenta.svg',
  Video: 'aktualne.svg',
  IhnedByznys: 'ihned.svg',
  IhnedDomaci: 'ihned.svg',
  IhnedZahranicni: 'ihned.svg',
  IhnedNazory: 'ihned.svg',
  IhnedArt: 'ihned.svg',
  IhnedEgo: 'ihned.svg',
  IhnedTech: 'ihned.svg',
  Magazin: 'aktualne.svg',
  Maminka: 'maminka.png',
  MagazinZahrada: 'magazinzahrada.png',
  AktualneAuto: 'aktualne.svg',
  FashionMagazin: 'fashionmagazin.png',
  VyberMiAuto: 'vybermiauto.svg',
  VitalWeb: 'vitalweb.svg',
  BabySUV: 'babysuv.svg',
  CzechSight: 'czechsight.png'
}

export const ALREADY_USED_ARTICLES_WIDGETS = [
  'dynamiclead',
  'news',
  'video',
  'woman',
  'sport',
  'magazine',
  'finance',
  'newsfeed'
]
